import React, { useEffect } from "react";
import { BASE_URL } from "./../../global";
import moment from "moment";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";


import {
  Button,
  TableContainer,
  TextField,
  Autocomplete, 
  Box,
  TablePagination,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import ExcelDownload from "../../utils/components/excelDownload";
import html2pdf from "html2pdf.js";
import DownloadPdfLoaderModal from "../../utils/components/downloadPdfLoader";
import { Table } from "react-bootstrap";

var form11Columns = [
  {
    id: "id",
    label: "Sr.No.",
    align: "left",
    minWidth: 40,
  },
// {
//   id: "reportNumber",
//   label: "Report Number",
//   align: "left",
//   minWidth: 40,
// },
  // {
  //   id: "equipment_name",
  //   label: "Name of Equipment",
  //   align: "left",
  //   minWidth: 40,
  // },
  {
    id: "factoryName",
    label: "Name of Factory Occupier",
    align: "left",
    minWidth: 70,
  },
  {
    id: "description",
    label: "Description",
    align: "center",
    minWidth: 40,
  },
{
  id: "reportNumber",
  label: "Report Number",
  align: "left",
  minWidth: 40,
},
  {
    id: "reportDate",
    label: "Date of Testing",
    align: "left",
    minWidth: 40,
  },
  {
    id: "certificateValidity",
    label: "Next due Date of Testing",
    align: "left",
    minWidth: 40,
  },
];

const notNeededColumn = ["id","shopId","templateId"];

const RenewalReport = (props) => {
  const printComponentRef = React.useRef();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [searchBy, setSearchBy] = React.useState("");
  const [searchKey, setSearchKey] = React.useState("");
  const [totalRows, setTotalRows] = React.useState(0);
  const _clientId = localStorage.getItem("clientId");
  const _userType = localStorage.getItem("type");
  const [from, setFrom] = React.useState(null);
  const [to, setTo] = React.useState(null);
  const [finalData, setFinalData] = React.useState([]);
  const [downloadPdfloading, setDownlaodPdfLoading] = React.useState(false);
  const [templateList, setTemplateList] = React.useState([]);
  const [factoryList, setFactoryList] = React.useState([]);
  const [shopsList, setShopsList] = React.useState([]);
  const [searched, setSearched] = React.useState(false);
  const [excelData, setExcelData] = React.useState([]);

  const [selectedIds, setSelectedIds] = React.useState({
    templateId: null,
    factoryId: null,
    shopId: null,
  });
  console.log("selectedIds", selectedIds);
  // let columns = selectedIds?.templateId == 12 ? form13Columns : form11Columns;
  let columns = form11Columns

  const getQuery = (count = false, removePagination = false) => {
    let whereConditions = "";
    let pagination_settings = "";
    let hasWhere = false;
  
    if (selectedIds?.templateId) {
      whereConditions += ` WHERE reportValues.templateId = ${selectedIds?.templateId}`;
      hasWhere = true;
    }
  
    if (selectedIds?.factoryId) {
      let colName =
        "REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.factoryId'), '\"', '')";
      whereConditions += hasWhere
        ? ` AND ${colName} = ${selectedIds?.factoryId}`
        : ` WHERE ${colName} = ${selectedIds?.factoryId}`;
      hasWhere = true;
    }
  
    if (selectedIds?.shopId) {
      let colName =
        "REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.shopId'), '\"', '')";
      whereConditions += hasWhere
        ? ` AND ${colName} = ${selectedIds?.shopId}`
        : ` WHERE ${colName} = ${selectedIds?.shopId}`;
      hasWhere = true;
    }
  
    if (to != null && from != null) {
      let colName =
        "DATE(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.certificateValidity'), '\"', ''))";
      whereConditions += hasWhere
        ? ` AND ${colName} BETWEEN DATE('${moment(from).format("YYYY-MM-DD")}') AND DATE('${moment(to).format("YYYY-MM-DD")}')`
        : ` WHERE ${colName} BETWEEN DATE('${moment(from).format("YYYY-MM-DD")}') AND DATE('${moment(to).format("YYYY-MM-DD")}')`;
      hasWhere = true;
    }else {
      // Default to last 10 days
      const tenDaysLater = moment().add(10, "days").format("YYYY-MM-DD");
      const today = moment().format("YYYY-MM-DD");
      let colName =
        "DATE(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.certificateValidity'), '\"', ''))";
      whereConditions += hasWhere
        ? ` AND ${colName} < DATE('${tenDaysLater}')`
        : ` WHERE ${colName} < DATE('${tenDaysLater}')`;
      hasWhere = true;
    }
    
    if (_userType == 3)
      whereConditions +=
        whereConditions.length > 0
          ? `and JSON_EXTRACT(reportValues.templateValues, '$.factoryId') = ${_clientId}`
          : `where JSON_EXTRACT(reportValues.templateValues, '$.factoryId') = ${_clientId}`;
  
    if (!removePagination && rowsPerPage != -1) {
      pagination_settings = `LIMIT ${rowsPerPage} OFFSET ${
        rowsPerPage * Number(page)
      }`;
    }
    
    let data = {
      query: `SELECT reportValues.templateId, reportValues.id,templates.name, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.reportNumber'), '\"', ''), '') AS reportNumber,      
       COALESCE(
      NULLIF(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.typeIdentificationNumber'), '\"', ''), ''),
      NULLIF(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.distinguishingNumber'), '\"', ''), ''),
      NULLIF(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.descriptionIdentification'), '\"', ''), ''),
      NULLIF(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.distinctiveNumber'), '\"', ''), ''),
      NULLIF(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.descriptionOfMachine'), '\"', ''), '')
    ) AS description, 
      IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.certificateValidity'), '\"', ''), '') AS certificateValidity, 
      IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.Occupier'), '\"', ''), '') AS factoryName, 
      IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.addressFactory'), '\"', ''), '') AS addressFactory, 
      IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.shopId'), '\"', ''), '') AS shopId, 
      IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.reportDate'), '\"', ''), '') AS reportDate, 
      clients.name AS client_name, 
      addresses.address AS client_address, 
      clients.emailId AS client_email, 
      shops.name AS shop_name, 
      products.name AS equipment_name 
      FROM reportValues 
      LEFT JOIN templates ON reportValues.templateId = templates.id 
      LEFT JOIN clients ON JSON_EXTRACT(reportValues.templateValues, '$.factoryId') = clients.id 
      LEFT JOIN addresses ON addresses.id = SUBSTRING_INDEX(clients.address, ',', 1) 
      LEFT JOIN shops ON REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.shopId'), '\"', '') = shops.id 
      LEFT JOIN products ON REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.equipmentId'), '\"', '') = products.id 
              ${whereConditions} 
              ORDER BY id ASC 
              ${pagination_settings}`,
    };
  
    if (count)
      data.query = `SELECT COUNT(*) AS no_of_rows FROM reportValues 
                    LEFT JOIN templates ON reportValues.templateId = templates.id 
                    ${whereConditions}`;
  
    return data;
  };

  // api calls
  function getTotalRows() {
    let data = getQuery(true);

    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then(async (res) => {
        setTotalRows(res.data[0]?.no_of_rows);
      })
      .catch((err) => {
        console.log("datasheet data fetching error: ", err);
      });
  }

  function fetchFinalData() {
    let data = getQuery();

    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then((res) => {
        setFinalData(res.data);
      })
      .catch((err) => {
        console.log("  error: ", err);
      });
  }

   function fetchAllDataForExcel() {
    const data = getQuery(false, true);
    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then((res) => {
        const formattedData = res.data.map((item) => ({
        ...item,
        reportDate: item.reportDate ? moment(item.reportDate).format("DD-MM-YYYY") : "-",
        certificateValidity: item.certificateValidity ? moment(item.certificateValidity).format("DD-MM-YYYY") : "-",
      }));
        setExcelData(formattedData);
      })
      .catch((err) => console.log("Failed to fetch data for Excel export"));
  }

  const search = () => {
    fetchFinalData();
    setSearched(true);
    getTotalRows();
    fetchAllDataForExcel();
  };

  const clearSearch = () => {
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched", searched);
    sessionStorage.removeItem("currentPath");
    setSearchBy("");
    setSearchKey("");
    setSearched(false);
    setSelectedIds({
     templateId: null,
    factoryId: null,
    shopId: null, 
    });
    setFrom(null); 
    setTo(null);
  };

  const generatePDF = () => {
    const doc = new jsPDF({
      orientation: "p",
      unit: "pt",
      format: "a4",
      compress: true,
    });

    // Title (centered)
    const pageWidth = doc.internal.pageSize.getWidth();
    const title = "Renewal Report";
    const textWidth = doc.getTextWidth(title);
    const x = (pageWidth - textWidth) / 2;

    doc.setFontSize(14);
    doc.text(title, x, 40);

    // Convert your columns into autoTable format
    const tableColumns = [
      { header: "Sr.No.", dataKey: "srno" },
      ...columns
        .filter((col) => col.id !== "id") // 👈 remove id column
        .map((col) => ({
          header: col.label,
          dataKey: col.id,
        })),
    ];

    // Prepare table rows
    const tableRows = excelData?.map((row, index) => {
      const formattedRow = {
        srno: index + 1, // 👈 SR NO (1,2,3…)
      };

      tableColumns.forEach((col) => {
        if (col.dataKey !== "srno") {
          formattedRow[col.dataKey] = row[col.dataKey] || "";
        }
      });

      return formattedRow;
    });

    // AutoTable
    autoTable(doc, {
      startY: 60,
      head: [tableColumns.map((c) => c.header)],
      body: tableRows.map((row) => Object.values(row)),
      theme: "grid",
      styles: {
        fontSize: 8,
        cellPadding: 4,
        textColor: 0,
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
      },
      headStyles: {
        fillColor: false,
        halign: "center",
      },
      bodyStyles: {
        halign: "left",
        valign:"middle"
      },
      margin: { left: 12, right: 12, bottom: 22, top: 30 },
    });

    doc.save("Renewal_Report.pdf");
  };


  // const generatePDF = async () => {
  //   setDownlaodPdfLoading(true);
  //   try {
  //     const element = printComponentRef.current;
  //     let pdf = await html2pdf()
  //       .from(element)
  //       .set({
  //         margin: [10, 1, 20, 1],
  //         filename: `masterInOut.pdf`,
  //         pagebreak: { after: "section", mode: ["css", "legacy"] },
  //         html2canvas: {
  //           dpi: 192,
  //           scale: 4,
  //           letterRendering: true,
  //           useCORS: true,
  //         },
  //         jsPDF: {
  //           orientation: "portrait",
  //           unit: "pt",
  //           format: "a4",
  //         },
  //       })
  //       .toPdf()
  //       .get("pdf");

  //     const totalPages = pdf.internal.getNumberOfPages();
  //     for (let i = 1; i <= totalPages; i++) {
  //       pdf.setPage(i);
  //       pdf.setFontSize(9);
  //       pdf.setTextColor(0, 0, 0);
  //       pdf.setFont("helvetica", "bold");

  //       // const text = "SUMMARY REPORT";
  //       // const pageWidth = pdf.internal.pageSize.getWidth();
  //       // const textWidth =
  //       //   (pdf.getStringUnitWidth(text) * 12) / pdf.internal.scaleFactor;
  //       // const x = (pageWidth - textWidth) / 2;
  //       // pdf.setFontSize(12);
  //       // pdf.text(text, x, 20);
  //     }

  //     const blob = pdf.output("blob");
  //     const url = URL.createObjectURL(blob);
  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = `summaryReport.pdf`;
  //     a.click();

  //     setDownlaodPdfLoading(false);
  //   } catch (error) {
  //     console.error("Error generating PDF:", error);
  //     setDownlaodPdfLoading(false);
  //   }
  // };

  const getAllTemplate = () => {
    axiosWithToken
      .get(BASE_URL + `templates`)
      .then((res) => {
        setTemplateList(res.data);
      })
      .catch((err) => {
        console.log(" error: ", err);
      });
  };

  const getAllFactory = () => {
    axiosWithToken
      .get(BASE_URL + `clients`)
      .then((res) => {
        setFactoryList(res.data);
      })
      .catch((err) => {
        console.log(" error: ", err);
      });
  };

  const getAllShops = () => {
    axiosWithToken
      .get(BASE_URL + `shops`)
      .then((res) => {
        setShopsList(res.data);
      })
      .catch((err) => {
        console.log(" error: ", err);
      });
  };

  var refresh = () => {
    window.location.reload(false);
  };

  useEffect(() => {
    getTotalRows();
    getAllTemplate();
    getAllFactory();
    getAllShops();
    fetchFinalData();
    fetchAllDataForExcel();
  }, []);

  useEffect(() => {
    fetchFinalData();
    getTotalRows();
    fetchAllDataForExcel();
  }, [rowsPerPage, page]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const TablePaginationActions = (props) => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  };

  return (
    <div>
      <div
        className="mb-2"
        style={{
          display: "flex",
          float: "left",
          flexWrap:"wrap",
          justifyContent: "flex-end",
          gap:"10px", 
          width:"95%",
          margin:"auto 10px"
        }}
      >
        <div>
        <Autocomplete
          sx={{
            m: 0,
            minWidth: 180,
          }}
          size="small"
          onChange={(event, newValue) => {
            setSelectedIds((prevState) => ({
              ...prevState,
              templateId: newValue ? newValue.id : null,
            }));
            setSearched(false);
          }}
          value={templateList.find(item => item.id == selectedIds.templateId) || null}
          options={templateList}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => (
            <TextField {...params} label="Select Form Type" />
          )}
        />
        </div>
        <div>
          <Autocomplete
            sx={{
              m: 0,
              minWidth: 150,
            }}
            size="small"
            onChange={(event, newValue) => {
              setSelectedIds((prevState) => ({
                ...prevState,
                factoryId: newValue ? newValue.id : null,
              }));
              setSearched(false);
            }}
            options={_userType == 3 ? factoryList?.filter((item) => item.id == _clientId): factoryList}
            value={factoryList.find(item => item.id === selectedIds.factoryId) || null}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField {...params} label="Select Factory" />
            )}
          />
        </div>

        <div
          style={{ width: "150px" }}
          id="quotationlist_datefrom"
        >
          <LocalizationProvider dateAdapter={AdapterDateFns} classNames="mr-2">
            <DatePicker
              slotProps={{ textField: { size: "small", fullWidth: true } }}
              label="From"
              value={from ? new Date(from) : ""}
              inputFormat="dd/MM/yyyy"
              format="dd/MM/yyyy"
              onChange={(newValue) => {
                setFrom(newValue);
              setSearched(false);
              }}
              renderInput={(params) => <TextField {...params} size="small" />}
            />
          </LocalizationProvider>
        </div>

        <div
          style={{ marginRight: "10px", width: "150px" }}
          id="quotationlist_dateto"
        >
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              slotProps={{ textField: { size: "small", fullWidth: true } }}
              label="To"
              value={to ? new Date(to) : ""}
              inputFormat="dd/MM/yyyy"
              format="dd/MM/yyyy"
              onChange={(newValue) => {
                setTo(newValue);
              setSearched(false);
              }}
              renderInput={(params) => <TextField {...params} size="small" />}
              style={{ marginRight: "20px" }}
            />
          </LocalizationProvider>
        </div>

        <Button
          variant="contained"
          size="small"
          sx={{ height: "40px" }}
          color={searched ? "error" : "primary"}
          onClick={() => {
             searched ? clearSearch() : search();
          }}
        >{searched ? <RestartAltIcon /> : <SearchIcon />}
        </Button>

        <ExcelDownload
          finalData={excelData}
          notNeededColumn={notNeededColumn}
        />

        <Button
          variant="contained"
          size="small"
          sx={{ height: "40px" }}
          onClick={() => {
            generatePDF();
          }}
        >
          Download PDF
        </Button>
      </div>
      <br />
      <TableContainer component={Paper} sx={{ mt: 2, p: 2 }}>
        <div
          style={{ border: "1px solid black", padding: "5px",  }}
          ref={printComponentRef}
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            size="small"
            id="invoicelist_table"
            sx ={{borderCollapse :"collapse",}}
          >
            <TableHead>
              <TableRow>
                {columns.map((column, index) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth, fontSize:"12px" }}
                  >
                    {/* {index === 1  ? (
                <b>{`${columns[1].label}  /  Plant`}</b>
              ) : ( */}
                    <b>{column.label}</b>
                    {/* )} */}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {finalData?.map((row, index) => (
                <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                  {columns.map((column, columnIndex) => {
                
                      let value;
                      if (
                        column.id === "certificateValidity" ||
                        column.id === "inspectionDate" ||
                        column.id === "hydraulicTestDate" ||
                        column.id === "internalTestDate" ||
                        column.id === "utrasonicTestDate" ||
                        column.id === "reportDate"
                      ) {
                        let newDate = moment(row[column.id]).format(
                          "DD-MM-YYYY"
                        );
                        value = row[column.id] ? newDate : null;
                      } else {
                        value = row[column.id];
                      }
                      if (column.id === "id") {
                        value = page * rowsPerPage + index + 1;
                      }

                         // Define dynamic style for certificateValidity column
                        let dynamicStyle = { fontSize: "12px" };
                        if (column.id === "certificateValidity" && row[column.id]) {
                          const isFuture = moment(row[column.id]).isAfter(moment(), "day");
                          dynamicStyle.color = isFuture ? "green" : "red";
                        }

                      return (
                        <TableCell key={column.id} align={column.align} style={dynamicStyle}>
                          {column.format && typeof value === "number"
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 100, { label: "All", value: -1 }]}
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          component="div"
          colSpan={3}
          SelectProps={{
            inputProps: {
              "aria-label": "rows per page",
            },
            native: true,
          }}
          ActionsComponent={TablePaginationActions}
        />
      </TableContainer>
      {downloadPdfloading && (
        <DownloadPdfLoaderModal
          loading={downloadPdfloading}
          name={"Renewal Report"}
        />
      )}
    </div>
  );
};

export default RenewalReport;